import { cnBase } from 'tailwind-variants';
import { Icon } from '../../../../../core/components/atoms/Icon';

const StepButton = ({
  label,
  onClick,
  className,
  icon,
  type = 'primary',
}: {
  label: string;
  onClick: () => void;
  className?: string;
  icon?: React.ReactNode;
  type?: 'primary' | 'text';
}) => {
  return (
    <button
      onClick={onClick}
      className={cnBase(
        className,
        `flex h-[38px] flex-row items-center justify-center gap-sm rounded-[8px] ${type === 'primary' ? 'min-w-[200px] bg-color-brand-primary  text-button-color-primary-default ' : 'text-mono-color-dark'} px-4 py-2 `
      )}
    >
      {icon}
      {label}
    </button>
  );
};

export default StepButton;
